import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Lodash
import _get from 'lodash/get';
import _find from 'lodash/find';

// Utils
import castArrayIfPresent from '@tekion/tekion-base/utils/castArrayIfPresent';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import FILTER_TYPES from '../../constants/filterSection.filterTypes';
var isEditedFilterDateFilter = function isEditedFilterDateFilter(filterId) {
  return function () {
    var filterType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
    var type = filterType.type,
      id = filterType.id;
    return id === filterId && type === FILTER_TYPES.DATE;
  };
};
var getDateRangeValues = function getDateRangeValues(startTime, endTime) {
  return startTime && endTime ? [startTime, endTime] : EMPTY_ARRAY;
};
var addPresetToAdditional = function addPresetToAdditional() {
  var filterDetails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var _filterDetails$values = filterDetails.values,
    values = _filterDetails$values === void 0 ? EMPTY_ARRAY : _filterDetails$values;
  var _values = _slicedToArray(values, 3),
    startTime = _values[0],
    endTime = _values[1],
    additional = _values[2];
  return _objectSpread(_objectSpread({}, filterDetails), {}, {
    values: getDateRangeValues(startTime, endTime),
    additional: castArrayIfPresent(additional)
  });
};
var addPresetToAdditionalInDateFilter = function addPresetToAdditionalInDateFilter(_ref) {
  var _ref$filterDetails = _ref.filterDetails,
    filterDetails = _ref$filterDetails === void 0 ? EMPTY_OBJECT : _ref$filterDetails,
    allFilters = _ref.allFilters,
    filterId = _ref.filterId,
    filterTypes = _ref.filterTypes;
  var filterType = _get(allFilters, "".concat(filterId, ".type"));
  var isDateFilter = _find(filterTypes, isEditedFilterDateFilter(filterType));
  if (!isDateFilter) {
    return filterDetails;
  }
  var updatedDateFilterDetails = addPresetToAdditional(filterDetails);
  return updatedDateFilterDetails;
};
export default addPresetToAdditionalInDateFilter;